import { EmptyState } from "@ui-kit/EmptyState";
import {
	PanelEmptyState,
	PanelEmptyStateDescription,
	PanelEmptyStateIcon,
	PanelEmptyStateTitle,
} from "@ui-kit/FloatingPanel";
import type { IconCode } from "@ui-kit/Icon";
import { Loader } from "@ui-kit/Loader";
import type { ReactNode } from "react";

export type ProviderPanelStatus = "loading" | "empty" | "not-found" | "ready";

export const providerPanelStatus = (loading: boolean, total: number, found: number): ProviderPanelStatus => {
	if (loading) return "loading";
	if (!total) return "empty";
	return found ? "ready" : "not-found";
};

type ProviderPanelBodyProps = {
	status: ProviderPanelStatus;
	loadingLabel: string;
	notFound: string;
	empty: { icon: IconCode; title: string; description: string };
	"data-testid"?: string;
	children: ReactNode;
};

export const ProviderPanelBody = ({
	status,
	loadingLabel,
	notFound,
	empty,
	"data-testid": testId,
	children,
}: ProviderPanelBodyProps) => {
	if (status === "loading") return <Loader aria-label={loadingLabel} className="py-6" size="3xl" />;
	if (status === "not-found") return <EmptyState data-testid={testId}>{notFound}</EmptyState>;
	if (status === "ready") return <>{children}</>;

	return (
		<PanelEmptyState data-testid={testId}>
			<PanelEmptyStateIcon icon={empty.icon} />
			<PanelEmptyStateTitle>{empty.title}</PanelEmptyStateTitle>
			<PanelEmptyStateDescription className="max-w-64">{empty.description}</PanelEmptyStateDescription>
		</PanelEmptyState>
	);
};
